import { render, staticRenderFns } from "./ModalTabelaRegrasEquipesMedicas.vue?vue&type=template&id=6da8f64f"
import script from "./ModalTabelaRegrasEquipesMedicas.vue?vue&type=script&lang=ts"
export * from "./ModalTabelaRegrasEquipesMedicas.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports